import { Geocoder } from './geocoder/geocoder';
import { NominatimGeocoder } from './geocoder/nominatim_geocoder';
import { PDOKGeocoder } from './geocoder/pdok_geocoder';

const pdok = () => new PDOKGeocoder();
const osm = () => new NominatimGeocoder();

const geocoder_types = {
	Geocoder, pdok, osm
}

export {
	geocoder_types
}